var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropPnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47221 5.47221C5.34719 5.59719 5.17766 5.6674 5.00088 5.6674C4.8241 5.6674 4.65456 5.59719 4.52955 5.47221L0.758213 1.70088C0.69454 1.63938 0.643751 1.56582 0.608812 1.48448C0.573873 1.40315 0.555482 1.31567 0.554713 1.22715C0.553943 1.13863 0.570811 1.05084 0.604332 0.968911C0.637853 0.88698 0.687355 0.812545 0.74995 0.749949C0.812545 0.687354 0.886979 0.637852 0.96891 0.604332C1.05084 0.570811 1.13863 0.553943 1.22715 0.554713C1.31567 0.555482 1.40315 0.573873 1.48448 0.608812C1.56582 0.643751 1.63938 0.694539 1.70088 0.758213L5.00088 4.05821L8.30088 0.758213C8.42661 0.636774 8.59502 0.569578 8.76981 0.571097C8.94461 0.572616 9.11182 0.642728 9.23542 0.766334C9.35903 0.889939 9.42914 1.05715 9.43066 1.23195C9.43218 1.40674 9.36499 1.57515 9.24355 1.70088L5.47221 5.47221Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropPnc);
export default __webpack_public_path__ + "static/media/dropPnc.0b84388aa1665a3cabe6d948286b184e.svg";
export { ForwardRef as ReactComponent };